import { observable } from "mobx";
import AccountingDocumentsInventoryCheckResultDownloadActionRejectionReason from "./accountingDocumentsInventoryCheckResultDownloadActionRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentsInventoryCheckResultDownloadActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: AccountingDocumentsInventoryCheckResultDownloadActionRejectionReason;
}
